import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class RateCalculatorForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'notZero',
			value => {
				return value != 0;
			},
			'NOTZEROVALUE'
		);
		Validator.register(
			'decimalLength',
			value => {
				var decimal = value.toString().split('.')[1];
				if (decimal) {
					return decimal.length <= 2;
				}
				return true;
			},
			'MINIMUMLENGHT'
		);
		return {
			fields: [
				'warehouse',
				'shipFromZipCode',
				'shipToZipCode',
				'isResidentialRecipient',
				'product',
				'weight',
				'lenght',
				'width',
				'height',
				'carriers[]',
				'showCheapestRate',
				'useThirdPartyAccounts',
			],
			labels: {
				product: 'RATECALCULATOR.SKU',
				warehouse: 'RATECALCULATOR.WAREHOUSE',
				shipFromZipCode: 'RATECALCULATOR.ZIPCODE',
				shipToZipCode: 'RATECALCULATOR.ZIPCODE',
				weight: 'RATECALCULATOR.WEIGHT',
				lenght: 'RATECALCULATOR.LENGHT',
				width: 'RATECALCULATOR.WIDTH',
				height: 'RATECALCULATOR.HEIGHT',
				carriers: 'RATECALCULATOR.CARRIERS',
			},
			rules: {
				shipFromZipCode: 'required',
				shipToZipCode: 'required',
				weight: 'required|numeric|notZero|decimalLength',
				lenght: 'required|numeric|notZero|decimalLength',
				width: 'required|numeric|notZero|decimalLength',
				height: 'required|numeric|notZero|decimalLength',
			},
			values: {
				showCheapestRate: false,
				isResidentialRecipient: false,
				useThirdPartyAccounts: false,
			},
		};
	}
	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/rate-calculator/forms/RateCalculatorForm.js